import { useState } from 'react';
import { usePOS } from '../context/POSContext';
import Receipt from './Receipt';
import Numpad from './Numpad';

function OrderSummary() {
  const {
    currentOrder,
    setCurrentOrder,
    activeTable,
    tables,
    completeOrder,
    createNewOrder,
    cartItems,
    total,
    currentBill,
    resetForNewOrder,
    removeFromCart,  // Assure-toi que cette fonction est bien fournie par ton contexte POS
  } = usePOS();

  const [showPayment, setShowPayment] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);

  const grandTotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  const handlePayment = async (amount) => {
    if (!cartItems.length) {
      alert('Le panier est vide');
      return;
    }

    const change = amount - grandTotal;
    if (change >= 0) {
      try {
        await createNewOrder(); // Crée la commande et la facture
        setShowPayment(false);
        setShowReceipt(true); // Affiche la facture
      } catch (error) {
        alert('La création de la commande a échoué');
      }
    } else {
      alert('Montant de paiement insuffisant');
    }
  };

  const handlePrintAndComplete = async () => {
    if (currentOrder?.id) {
      window.print(); // Déclenche l'impression
      await completeOrder(currentOrder.id); // Finalise la commande après impression
    }
    setShowReceipt(false);
    resetForNewOrder(); // Réinitialise pour une nouvelle commande
  };

  const getTableName = () => {
    if (!activeTable) return 'Pas de table sélectionnée';
    const table = tables.find(t => t.id === activeTable?.id);
    return table ? `Table ${table.tableNumber}` : 'Table introuvable';
  };

  return (
    <div className="h-full flex flex-col">
      <div
        className="py-3 px-4"
        style={{ backgroundColor: '#fdf54d' }}
      >
        <h2 className="font-bold text-lg">Commande en cours</h2>
        <p className="text-sm">{getTableName()}</p>
      </div>

      {!cartItems.length && !showReceipt ? (
        <div className="flex-1 flex flex-col items-center justify-center p-6 text-gray-500">
          <p>Votre panier est vide.</p>
        </div>
      ) : showPayment ? (
        <div className="flex-1 flex flex-col p-4 overflow-auto">
          <h3 className="font-bold text-lg mb-4">Paiement</h3>
          <Numpad
            initialValue={grandTotal.toFixed(2)}
            onSubmit={handlePayment}
            buttonLabel="Traiter le paiement"
          />
          <button
            className="mt-4 py-2 rounded-md transition-colors"
            style={{ backgroundColor: '#fdf54d', color: 'black' }}
            onClick={() => setShowPayment(false)}
          >
            Annuler
          </button>
        </div>
      ) : showReceipt ? (
        <div className="flex-1 flex flex-col p-4 overflow-auto printable-receipt-container">
          <Receipt bill={currentBill} showActions={false} />
          <button
            onClick={handlePrintAndComplete}
            className="mt-4 py-2 rounded-md transition-colors print-hidden"
            style={{ backgroundColor: '#fdf54d', color: 'black' }}
          >
            Imprimer & Finaliser la commande
          </button>
        </div>
      ) : (
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="flex-1 overflow-auto p-4">
            {cartItems.map((item, index) => (
              <div key={index} className="flex items-center justify-between py-2 border-b">
                <div className="flex-1">
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-gray-600">{item.price.toFixed(2)} MAD</p>
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-sm">Quantité : {item.quantity}</span>
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="text-red-600 hover:text-red-800 text-sm underline mt-1"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-200">
            <div className="p-4">
              <div className="flex justify-between font-bold text-lg">
                <span>Total:</span>
                <span>{grandTotal.toFixed(2)} MAD</span>
              </div>
              <button
                onClick={() => setShowPayment(true)}
                className="w-full py-3 rounded-md mt-4 transition-colors"
                style={{ backgroundColor: '#fdf54d', color: 'black' }}
              >
                Paiement
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderSummary;
